import { FaTicket, FaStar, FaUsers } from 'react-icons/fa6';

const pricing = [
    {
        id: 1,
        icon: <FaTicket />,
        title: 'Standard Admission',
        price: 29.99,
        features: [
            'Full Session Access',
            'Event Materials',
            'Networking Lounge',
            'Complimentary Drinks',
            'Transparent Pricing',
        ],
    },
    {
        id: 2,
        icon: <FaStar />,
        title: 'VIP Admission',
        price: 99.99,
        features: [
            'All Standard Benefits',
            'Front-Row Seating',
            'Exclusive Networking',
            'Speaker Meet & Greet',
            'Access to VIP Lounge',
        ],
    },
    {
        id: 3,
        icon: <FaUsers />,
        title: 'Group Admission',
        price: 199.99,
        features: [
            'Entry for 5 Attendees',
            'Group Savings',
            'Session Materials',
            'Team Networking Access',
            'No Extra Charges',
        ],
    },
];

export default pricing;